module.exports = __webpack_public_path__ + "img/xihannanyuewangbowuguan.ae442f5f.png";